import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=54774abe&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=js"
export * from "./ActionButton.vue?vue&type=script&lang=js"
import style0 from "./ActionButton.vue?vue&type=style&index=0&id=54774abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54774abe",
  null
  
)

export default component.exports